<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '350px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: rgb(255, 255, 255)">
	<div class="filter-body">
		<!-- 				 -->
		<!-- School Selector -->
		<!-- 				 -->
		<div class="filter-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>
		</div>

		<!-- 		    		   -->
		<!-- Image Group Selector  -->
		<!-- 			     	   -->
		<div class="filter-item">
			<div>
				<label>Image Group</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="ImageGroupSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedImageGroup"
					(ngModelChange)="onImageGroupChange($event)"
				>
					<option *ngFor="let r of lstImageGroup" [ngValue]="r">
						{{ r.ImageLibraryGroupDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div style="padding: 20px; background-color: rgb(235, 235, 235)">
		<label for="fileSelectImages" class="btn btn-primary" style="margin-left: 0px">Add Image</label>
		<input
			id="fileSelectImages"
			type="file"
			(change)="onAdd($event)"
			onclick="event.target.value=''"
			style="visibility: hidden; position: absolute"
			accept="image/*"
		/>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Image</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onRename()">Rename Image</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete Image</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onCopy()">Copy Image</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onSetDistrict()" [disabled]="isDistrictUser == false">Set District</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAssociate()" [disabled]="SelectedImageGroup.UserCanAssociate == false">
			Associate Image
		</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: rgb(235, 235, 235)" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Images in library: {{ ImageLibraryList.length }}</label
		><br />
		<label>&#9900; Click on item to select.</label><br />
		<label>&#9900; District level images have a orange background.</label><br />
		<label>&#9900; School level images have a gray background.</label><br />
		<label>&#9900; District Images that are locked and cannot be edited are light red.</label><br />
		<label>&#9900; School Images that are locked and cannot be edited are light-light red.</label><br />
	</div>
</div>

<!-- 				   -->
<!-- Display When Busy -->
<!-- 				   -->
<div style="padding: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
	<img class="busy-img" src="assets/images/loading.gif" />
</div>

<!-- 						-->
<!-- Display When No Photos -->
<!-- 					    -->
<div style="padding: 20px" [style.display]="ImageLibraryList.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>Image Library Is Empty...</label>
</div>

<!-- 				-->
<!-- Display Photos -->
<!-- 				-->
<div class="flex-container" [style.display]="isBusy == false ? 'flex' : 'none'">
	<div
		*ngFor="let obj of ImageLibraryList"
		class="flex-container-stamp"
		[ngClass]="{
			'stamp-item-selected': obj?.IsSelected == true,
			'stamp-item-unselected': obj?.IsSelected == false,

			'flex-container-stamp-assign-district': obj?.SchoolID <= 0 && obj?.isImageLocked == false,
			'flex-container-stamp-assign-district-locked': obj?.SchoolID <= 0 && obj?.isImageLocked == true,

			'flex-container-stamp-assign-school': obj?.SchoolID > 0 && obj?.isImageLocked == false,
			'flex-container-stamp-assign-school-locked': obj?.SchoolID > 0 && obj?.isImageLocked == true
		}"
	>
		<div class="flex-container-stamp-body" (click)="onSelectItem($event, obj)">
			<div class="stamp-column1-body">
				<img class="stamp-column1-fix-img" [src]="obj.ImageLibraryData_Thumb" />
			</div>

			<div class="stamp-column2-body">
				<div *ngIf="obj?.UserCanAssociate == false">
					<div class="stamp-column2-body">
						<div>
							<label class="stamp-column2-heading">File Name</label>
						</div>
						<div>
							<label class="stamp-column2-data-3line">{{ obj.ImageLibraryItemName }}</label>
						</div>
					</div>
				</div>

				<div *ngIf="obj?.UserCanAssociate == true">
					<div class="stamp-column2-body">
						<div>
							<label class="stamp-column2-heading">File Name</label>
						</div>
						<div>
							<label class="stamp-column2-data-2line">{{ obj.ImageLibraryItemName }}</label>
						</div>
						<div>
							<label class="stamp-column2-heading">Associations</label>
						</div>
						<div>
							<label class="stamp-column2-data-3line">{{ obj.AssociationDesc }}</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
